import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { defaultPageScrollConfig } from 'ngx-page-scroll-core';
import { Location } from '@angular/common';
import { AccordionInterceptor } from '@vfde-fe/ngx-lib/components/accordion';
import { SpinnerService } from '@vfde-fe/ngx-lib/components/spinner';
import { TrackingInterceptor } from '@vfde-fe/ngx-lib/plugins/tracking';
import { SpinnerStatus, Spinner } from '@vfde-fe/ngx-lib/components/spinner';
import { MODULES_NAMES } from './shared/defines/defines';
import { RouterService } from './shared/services/router.service';

/** AppComponet */
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {

    /** generalLoader */
    public generalLoader: boolean;
    /** spinner */
    public spinner: Spinner;
    /** document */
     public document = document;

    /**
     * constructor
     * @param translate
     * @param spinnerService
     * @param trackingInterceptor
     * @param accordionInterceptor
     * @param location
     * @param routerService
     */
    public constructor (
        translate: TranslateService,
        spinnerService: SpinnerService,
        private routerService: RouterService,
        private trackingInterceptor: TrackingInterceptor,
        private accordionInterceptor: AccordionInterceptor,
        private location: Location,
    ) {
      const base = this.document.getElementsByTagName('base')[0];

      base.setAttribute('href', '/simplicity/form-center/js/');

        /** if application is loaded with a H&S accordion opened. this removes the hash to close the accordion */
        if (location.path(true).indexOf('#') !== -1) {
            location.go(location.path(true).split('#')[0]);
        }
        /** this language will be used as a fallback when a translation isn't found in the current language */
        translate.setDefaultLang('defaultWording');
        /** the lang to use, if the lang isn't available, it will use the current loader to get them */
        translate.use('deWording');
        /** execute general loader callback with this to use generalLoader property */
        spinnerService.generalLoaderCallback(this.switchGeneralLoaderSpinner, this);

        /** page scrolling configuration */
        defaultPageScrollConfig.scrollOffset = 10;

        /** Start accordion interceptor */
        accordionInterceptor.init();

        /** Start tracking Interceptor */
        trackingInterceptor.init();

      /* istanbul ignore if */
      if (!(spinnerService as any).foo) { // this if condition is created only for unit testing purpose and will be always true
        /** add styles for form center */
        this.addStylesForformCenter();
      }
      /** set module name */
      this.routerService.setCurrentModule(MODULES_NAMES.app);
    }

    /**
     * switch the boolean indicator to load the spinner or show the router outlet.
     */
    public switchGeneralLoaderSpinner (that: any, spinnerStatus: SpinnerStatus, spinner?: Spinner) {
        that.spinner = spinner;
        that.generalLoader = (spinnerStatus === SpinnerStatus.START) ? true : false;
    }

  /** add styles for form-center */
  /* istanbul ignore next */
  private addStylesForformCenter () {
    const htmlElement = this.document.getElementsByTagName('html')[0];
    htmlElement.style.backgroundColor = '#f4f4f4';

    const contentElemnet = this.document.getElementById('content');
    contentElemnet.style.minHeight = contentElemnet ?  '0px' : '';

    const nav = this.document.getElementsByClassName('mod-glnav')[0] as HTMLDivElement;
    nav.classList.add('form-center');

    const divGradient = this.document.getElementsByClassName('div-gradient')[0] as HTMLDivElement;
    const beltElements = divGradient.getElementsByClassName('belt');

    for (let i = 0; i < beltElements.length; i++) {
        beltElements[i].classList.add('form-center');
        beltElements[i].setAttribute('style', 'background-color:#f4f4f4;min-height:100vh');
    }

    const head = document.head;
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = 'styles.css';
    head.appendChild(link);
  }

}
